{
  "common": {
    "cancel": "Cancel",
    "save": "Save",
    "delete": "Delete",
    "edit": "Edit",
    "done": "Done",
    "loading": "Loading...",
    "syncing": "Syncing...",
    "error": "Error",
    "success": "Success",
    "retry": "Retry",
    "share": "Share",
    "join": "Join",
    "by": "by"
  },
  "auth": {
    "signIn": "Sign In",
    "signUp": "Sign Up",
    "signOut": "Sign Out",
    "signInRequired": "Sign in required",
    "signInDescription": "Please sign in to continue with this action",
    "continueWithGoogle": "Continue with Google",
    "continueWithApple": "Continue with Apple",
    "welcomeBack": "Welcome back!",
    "createAccount": "Create an account to get started"
  },
  "tabs": {
    "home": "Home",
    "zones": "Zones",
    "create": "Create",
    "profile": "Profile",
    "settings": "Settings"
  },
  "settings": {
    "title": "Settings",
    "appearance": "Appearance",
    "theme": "Theme",
    "themeLight": "Light",
    "themeDark": "Dark",
    "themeSystem": "System",
    "language": "Language",
    "languageEnglish": "English",
    "languageSpanish": "Spanish"
  },
  "post": {
    "title": "Title",
    "titlePlaceholder": "An interesting title",
    "body": "Body",
    "bodyPlaceholder": "Write your post here...",
    "selectZone": "Select a zone",
    "postTo": "Post to",
    "posting": "Posting...",
    "post": "Post",
    "deletePost": "Delete post",
    "deleteConfirm": "Are you sure you want to delete this post?",
    "deleteWarning": "This action cannot be undone. Are you sure you want to permanently delete this post?",
    "options": "Post options",
    "addLink": "Add Link",
    "linkPlaceholder": "Paste a YouTube, X (Twitter), or other link",
    "linkHint": "Supported: YouTube, X (Twitter), and direct links",
    "comments": "comments",
    "noComments": "No comments yet",
    "addComment": "Add a comment",
    "reply": "Reply",
    "showReplies": "Show replies",
    "hideReplies": "Hide replies",
    "upvote": "Upvote",
    "downvote": "Downvote",
    "maxImages": "Maximum {{count}} images allowed",
    "videoSelected": "Video selected",
    "compressingVideo": "Compressing video...",
    "videoReady": "Video ready",
    "loadingCompressor": "Loading compressor...",
    "finalizingVideo": "Finalizing...",
    "compressing": "Compressing",
    "uploadingVideo": "Uploading video"
  },
  "zone": {
    "search": "Search zones",
    "noZones": "No zones found",
    "members": "members",
    "member": "member",
    "createZone": "Create Zone",
    "zoneName": "Zone Name",
    "zoneNamePlaceholder": "Enter zone name",
    "zoneDescription": "Description",
    "zoneDescriptionPlaceholder": "What is this zone about?",
    "creating": "Creating...",
    "create": "Create",
    "allTopics": "All Topics",
    "selectType": "Zone Type",
    "selectTopics": "Topics",
    "posts": "Posts",
    "about": "About",
    "joined": "Joined",
    "leave": "Leave",
    "online": "Online",
    "offline": "Offline",
    "players": "players",
    "recruiting": "Recruiting",
    "notRecruiting": "Not Recruiting",
    "types": {
      "general": "General",
      "server": "Server",
      "project": "Project",
      "guild": "Guild",
      "feedback": "Feedback"
    },
    "typeDescriptions": {
      "general": "Broad discussions, memes, art, lore",
      "server": "Multiplayer server community",
      "project": "Mods and creations",
      "guild": "Player groups and clans",
      "feedback": "Bug reports and suggestions"
    },
    "serverFields": {
      "serverIp": "Server IP",
      "serverPort": "Port",
      "region": "Region",
      "status": "Status",
      "modsUsed": "Mods Used"
    },
    "projectFields": {
      "version": "Version",
      "downloadUrl": "Download",
      "repositoryUrl": "Repository",
      "compatibility": "Compatibility"
    },
    "guildFields": {
      "recruiting": "Recruiting",
      "discordUrl": "Discord",
      "roster": "Member Roster"
    },
    "topics": {
      "adventure": "Adventure",
      "building": "Building",
      "combat": "Combat",
      "creative": "Creative",
      "minigames": "Minigames",
      "modding": "Modding",
      "pvp": "PvP",
      "roleplay": "Roleplay",
      "survival": "Survival",
      "trading": "Trading",
      "tutorials": "Tutorials",
      "news": "News",
      "art": "Art",
      "memes": "Memes",
      "lore": "Lore",
      "technical": "Technical"
    }
  },
  "errors": {
    "loadFailed": "Failed to load data",
    "postFailed": "Failed to create post",
    "commentFailed": "Failed to add comment",
    "deleteFailed": "Failed to delete",
    "signInFailed": "Sign in failed. Please try again.",
    "saveFailed": "Failed to save. Please try again."
  },
  "username": {
    "setupTitle": "Choose your username",
    "setupDescription": "Your username is how others will find and mention you. This will be used for your profile URL.",
    "changeTitle": "Change username",
    "changeDescription": "You can change your username once every 30 days.",
    "placeholder": "username",
    "hint": "3-20 characters. Letters, numbers, and underscores only.",
    "taken": "This username is already taken",
    "continue": "Continue",
    "cooldownTitle": "Username Change Cooldown",
    "cooldownMessage": "You can change your username again in {{days}}"
  },
  "empty": {
    "noPosts": "No posts yet",
    "beFirst": "Be the first to share something!"
  },
  "home": {
    "newPostsAvailable": "New posts available"
  },
  "profile": {
    "title": "Profile",
    "editProfile": "Edit Profile",
    "karma": "Karma",
    "posts": "Posts",
    "memberSince": "Member since",
    "noPosts": "No posts yet",
    "createFirstPost": "Create your first post!",
    "yourPosts": "Your Posts"
  }
}
